import React from "react";
import StimulusPostCard from "./StimulusPostCard";
import LikertBatteryQuestion from "./LikertBatteryQuestion";

/**
 * Composite survey question: renders a social media stimulus (post or
 * post+comment) followed by Likert perception rating scales.
 *
 * Props:
 *   question  - {
 *     questionId,
 *     stimulus: { post, comment? },
 *     stimulusType: "post" | "post_comment",
 *     ratingTarget: "post" | "comment",
 *     perceptionItems: [{ itemId, text }],
 *     scale: { points, labels },
 *   }
 *   responses - flat response map
 *   onChange  - (questionId, value) callback
 */
const StimulusPerceptionQuestion = ({ question, responses, onChange }) => {
  const {
    questionId,
    stimulus = {},
    stimulusType,
    ratingTarget,
    perceptionItems = [],
    scale = {},
  } = question;

  const isCommentTarget = ratingTarget === "comment";

  // Construct a LikertBatteryQuestion-compatible question object
  // so we can reuse the existing component for the rating scales.
  const likertQuestion = {
    questionId,
    items: perceptionItems,
    scale,
  };

  return (
    <div className="space-y-5">
      {/* Stimulus card */}
      <StimulusPostCard
        post={stimulus.post}
        comment={stimulusType === "post_comment" ? stimulus.comment : undefined}
        highlightComment={isCommentTarget}
      />

      {/* Divider with rating instruction */}
      <div className="border-t border-spiders-border pt-4">
        <p className="text-sm text-spiders-text-secondary mb-1">
          {isCommentTarget
            ? "Please rate the highlighted comment on the following dimensions:"
            : "Please rate the post above on the following dimensions:"}
        </p>
      </div>

      {/* Likert rating scales — reuses existing component */}
      <LikertBatteryQuestion
        question={likertQuestion}
        responses={responses}
        onChange={onChange}
      />
    </div>
  );
};

export default StimulusPerceptionQuestion;
